export const VERTICAL_OFFSET = 3;
export const DEFAULT_CIRCLE_SIZE = 20;
export const INACTIVE_CIRCLE_SIZE = 12;
export const ACTIVE_BORDER_SIZE = 4;
